var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatarMale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 59,
    viewBox: "0 0 58 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23181_409196)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_23181_409196",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 59,
    height: 59
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.0052 58.1069C45.0243 58.1069 58.0104 45.1208 58.0104 29.1017C58.0104 13.0826 45.0243 0.0964966 29.0052 0.0964966C12.9861 0.0964966 0 13.0826 0 29.1017C0 45.1208 12.9861 58.1069 29.0052 58.1069Z",
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_23181_409196)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.557739 6.78878C-0.557739 2.16871 3.18757 -1.5766 7.80764 -1.5766H49.6346C54.2547 -1.5766 58 2.16871 58 6.78878V62.558H-0.557739V6.78878Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.24 -7.84192H-12.6719V96.3004H65.24V-7.84192Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1525 10.6535C21.1525 10.6535 25.3364 4.88361 32.7731 4.88348C48.2084 4.88321 46.5347 19.6526 36.4934 16.8404C30.357 22.0258 33.3755 31.2416 28.6568 30.8415C22.8281 30.3436 19.5104 26.9585 18.7512 23.8421C17.9921 20.7256 17.7124 15.4016 21.1525 10.6535Z",
    fill: "#BEC5D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.924 21.5653C23.924 21.5653 24.3598 13.4802 31.0185 12.7158C36.0561 12.1348 37.8515 17.8569 37.9648 24.2298C38.0781 30.6026 36.1825 34.7784 31.8639 33.8393C27.31 32.8303 24.5995 30.69 23.5405 27.2873C23.5405 27.2873 20.0543 26.9423 20.3245 23.1596C20.6426 18.9489 23.924 21.5653 23.924 21.5653Z",
    fill: "#F4F5F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6319 40.8075C35.6319 40.8075 31.5577 39.3368 32.4135 32.4413L22.9278 25.6602C22.9278 25.6602 23.6276 38.8392 18.751 40.0237C18.751 40.0237 21.5013 52.3528 28.8831 52.6655C33.3675 52.89 35.2263 44.0835 35.6319 40.8075Z",
    fill: "#F4F5F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1797 33.7637C32.1797 33.7637 26.3999 31.3129 25.2696 30.0853C24.1393 28.8577 24.8281 32.0847 26.7797 34.4046C27.9012 35.7586 30.9125 37.6406 32.7758 37.8663C32.7758 37.8663 32.1399 36.562 32.1797 33.7637Z",
    fill: "#E1E8EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0179 119.473C66.0179 119.473 66.2778 102.877 63.5507 81.6267C61.2474 63.6734 56.9599 55.4261 50.306 48.6441C44.7706 43.0022 35.4882 40.8876 35.4882 40.8876C33.5596 42.2978 31.2215 43.0404 28.8301 43.0022C27.1414 42.967 21.4578 42.6857 18.7902 40.1226C17.5147 40.1073 16.2459 40.308 15.0378 40.7161C1.05595 44.9849 -5.72555 56.3493 -9.13394 73.8948C-10.9462 83.2194 -12.9876 91.2736 -14.2311 101.319L53.4076 114.78C53.1651 110.384 52.0848 92.7989 51.8158 88.5476C51.8158 88.5476 49.9597 111.358 55.5727 111.13C67.5438 110.646 61.2647 143.833 66.0179 119.473Z",
    fill: "#EAF0F4"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23181_409196"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    fill: "white",
    transform: "translate(0 0.0964966)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarMale);
export default __webpack_public_path__ + "static/media/avatar-male.8c8ea9dcc96e875f36cae58f26ff24ec.svg";
export { ForwardRef as ReactComponent };